module.exports = "<div class=footer-copyright> <a href=https://beian.miit.gov.cn/#/Integrated/index target=_blank>版权所有 ©2017 鞍钢招标有限公司 辽ICP备11001555号-3</a> <a href=\"http://wljg.lngs.gov.cn/iciaicweb/dzbscheck.do?method=change&id=E2016091800068932\" target=_blank> <img src=" + require("../../../../static/img/home/suppliers/guohui.png") + " height=22 width=22 /> </a> </div> <div class=footer-information> 辽宁省鞍山市立山区中华北路25号 114033 </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/home/footer.html
// module id = 531
// module chunks = 21 54 55 56 68 77 79 80 88